import {
  TabletAppSettings,
  TabletCategoriesViewOptions,
  TabletItemsListViewOptions
} from "@/config/constant";
import { formatListOptions } from "../../../../Utils/formatters";
const createObj = configModel => {
  const model = {};
  Object.keys(configModel).map(x => (model[x] = null));
  return model;
};

export const models = createObj(TabletAppSettings);

export const options = {
  CategoriesViewOptions: formatListOptions(TabletCategoriesViewOptions),
  ItemsListViewOptions: formatListOptions(TabletItemsListViewOptions)
};

export const Fields = [
  {
    label: "Tablet App Settings",
    type: "spacer",
    line: false,
    xl: "12"
  },
  {
    label: "",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Choose Cover Screen",
    name: TabletAppSettings.CoverScreen,
    placeholder: "Upload your amazing cover screen saver",
    type: "file",
    multiple: false,
    value: "",
    xl: "5",
    bodyClasses: "single-image",
    validationMessage: {
      required: "This field is required"
    }
  },
  {
    label: "Preview Preferences",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Categories View",
    name: TabletAppSettings.CategoriesView,
    placeholder: "",
    type: "select",
    value: "",
    xl: "4",
    options: options.CategoriesViewOptions
  },
  {
    label: "Items List View",
    name: TabletAppSettings.ItemsListView,
    placeholder: "",
    type: "select",
    value: "",
    xl: "4",
    options: options.ItemsListViewOptions
  },
  {
    label: "",
    type: "spacer",
    line: false,
    xl: "12"
  },
  {
    label: "Preview Cart",
    name: TabletAppSettings.CartVisible,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Enable Ordering",
    name: TabletAppSettings.EnableOrdering,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },
  {
    label: "Preview Prices",
    name: TabletAppSettings.PreviewPrices,
    placeholder: "",
    type: "checkbox",
    change: "checkHasValue",
    xl: "2"
  },

  {
    label: "Pass keys",
    type: "spacer",
    line: true,
    xl: "12"
  },
  {
    label: "Pass key",
    name: TabletAppSettings.PassKey,
    placeholder: "enter 4 pin key",
    type: "number",
    value: "",
    xl: "4",
    rules: "digits:4"
  }
];
